import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { TracePropagationInterceptor } from './trace-propagation.interceptor';
import { PopupModule } from 'shared/popup-service/popup.module';
import { AuthTokenServiceModule } from '@kempoweroyj/ngx-auth-token-service';

@NgModule({
    declarations: [],
    imports: [CommonModule, PopupModule, AuthTokenServiceModule],
    exports: [],
    providers: [
        AuthService,
        ConfigService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TracePropagationInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class CeProvidersModule {}
